import { apiClient } from '@/api/client'
import { useAuthStore } from '@/stores/useAuthStore'

interface SignUpProps {
    firstname: string
    lastname: string
    email: string
    password: string
}

export const signUp = async ({ firstname, lastname, email, password }: SignUpProps) => {
    const payload = {
        email,
        firstname,
        lastname,
        password,
    }
    await apiClient.post('/users/', payload)
}

export const logOut = async () => {
    await apiClient.post('/auth/logout')
    useAuthStore.getState().signOut()
}

export const deleteCurrentUser = async () => {
    await apiClient.delete('/users/')
}

export const changePassword = async ({
    oldPassword,
    newPassword,
}: {
    oldPassword: string
    newPassword: string
}) => {
    await apiClient.post('/auth/change-password', {
        old_password: oldPassword,
        new_password: newPassword,
    })
}
